/*
 * LeaveRequests Messages
 *
 * This contains all the text for the LeaveRequests component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.LeaveRequests.header',
    defaultMessage: 'Leave Requests',
  },
  request: {
    id: 'app.components.LeaveRequests.request',
    defaultMessage: 'Request for Leave',
  },
  noRequests: {
    id: 'app.components.LeaveRequests.noRequests',
    defaultMessage: 'No requests for leave',
  },
  draft: {
    id: 'app.components.LeaveRequests.draft',
    defaultMessage: 'Draft',
  },
  submitted: {
    id: 'app.components.LeaveRequests.submitted',
    defaultMessage: 'Submitted',
  },
  approved: {
    id: 'app.components.LeaveRequests.approved',
    defaultMessage: 'Approved',
  },
  rejected: {
    id: 'app.components.LeaveRequests.rejected',
    defaultMessage: 'Rejected',
  },
  deleted: {
    id: 'app.common.deleted',
    defaultMessage: 'Deleted',
  },
  revoked: {
    id: 'app.components.LeaveRequests.revoked',
    defaultMessage: 'Revoked',
  },
  revoke: {
    id: 'app.common.revoke',
    defaultMessage: 'Revoke',
  },
  revokeRequest: {
    id: 'app.components.LeaveRequests.revokeRequest',
    defaultMessage: 'Revoke the request?',
  },
  lateBecause: {
    id: 'app.components.LeaveRequests.lateBecause',
    defaultMessage: 'Late request because',
  },
  emplEntrepreneur: {
    id: 'app.components.RequestForm.emplEntrepreneur',
    defaultMessage: 'Entrepreneur',
  },
  emplEmployed: {
    id: 'app.components.RequestForm.emplEmployed',
    defaultMessage: 'Paid Employment',
  },
  couldNotDelete: {
    id: 'app.components.RequestForm.couldNotDelete',
    defaultMessage: 'The request could not be revoked',
  },
});
